import { useRouteQuery } from '@vueuse/router'

export default (name: string) => useRouteQuery<string | null, number | null>(name, null, { transform: v => v === null ? null : Number(v) })
